import {Errors} from '@/helpers/Errors';
export default {
    namespaced: true,
    state: {
        bread_active: null,
        bread_list: null,
        teamList: null,
        formData: {},
        myError: null,
        idTeamToDelete: 0,
        errors: new Errors(),
    },
    getters: {},
    mutations: {
        SET_DATA(state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {
        classicList(state) {
            axios.get('/api/v2/team/classicList')
                .then(response => {
                    state.commit('SET_DATA', {name: 'teamList', data: response.data});
                })
        },

        sendTeamData(state, payload) {
            axios.post('/api/v2/team/save', {
                name: payload.name,
                email: payload.email,
                phone: payload.phone,
                password: payload.password,
                profession: payload.profession,
                id: payload.id,
            })
                .then(() => {
                    state.dispatch('classicList');
                })
                .catch(error =>{
                    state.state.errors.record(error.response.data.errors);
                })
        },

        deleteTeam(state)
        {
            axios.get('/api/v2/team/' + state.state.idTeamToDelete + '/delete')
                .then(() => {
                    state.dispatch('classicList');
                })
        }
    }
}
